
import React from "react";
import { Icon } from "@abb/abb-common-ux-react";
import { ABB_LEFT, ABB_RIGHT, ABB_CARET_DOWN, ABB_CARET_UP, ABB_CHECK_MARK } from '../../utilities/IconConstants';
import { IInstrumentDetails } from "../../models/measurement/InstrumentDetails";
import { IKeyedInDetails } from '../../models/measurement/KeyedInDetails';
import { ICalculatedDetails } from "../../models/measurement/CalculatedDetails";
import { Translation } from "react-i18next";
import * as CONSTANTS from "../../utilities/Constants";
import { ND } from '../../utilities/Constants';
import PropertyMeasurement from './PropertyMeasurement';
import { AppContextConsumer } from './MeasurementLanding';
import SampleLoadingIndicator from '../shared/SampleLoadingIndicator';
import PropertyTable from './PropertyTable';
import MeasurementTable from './MeasurementTable';
import IThresholdSettings from "../../models/settings/ThresholdSettings";

interface ITabContent {
    details?: boolean;
    selectedInstrumentDetail?: IInstrumentDetails;
    activeDirectionIndx?: number;
    selectedKeyedInDetails?: IKeyedInDetails;
    selectedCalculatedDetails?: ICalculatedDetails;
    onDirectionHandler?: (selectedId: string, instrumentId: string, position: number) => void;
    onKeyedInDirectionHandler?: (selectedId: string, keyedInId: string, position: number) => void;
    keyedInSection?: boolean;
    onChangeKeyedIn?: (e: any, count: number, propertyId: string) => void;
    calculatedSection?: boolean;
    measuredSection?: boolean;
    onMeasuredPositionChange?: (index: number) => void;
    onKeyedInPositionChange?: (index: number) => void;
    isLoadingText?: boolean;
    isFullScreenVisible?: boolean;
    showSummary?: boolean;
    thresholdSettings?: IThresholdSettings[];
    onSetActiveDirectionIndx?: (index: number) => void;
}

interface ITabContentState {
    activeMeasuredIndex: number;
    activeIndex: number;
    activeDirectionIndx: number;
}

export default class TabContent extends React.Component<ITabContent, ITabContentState> {

    constructor(props: ITabContent) {
        super(props);
        this.state = {
            activeMeasuredIndex: this.props.selectedInstrumentDetail?.setPositionVal,
            activeIndex: this.props.selectedKeyedInDetails?.setPositionVal,
            activeDirectionIndx: this.props.activeDirectionIndx ? this.props.activeDirectionIndx : 0
        }
        this.onScroll = this.onScroll.bind(this)
    }

    public componentDidUpdate(prevProps: any, prevState: any) {
        if (this.props !== prevProps) {
            this.setState({
                activeMeasuredIndex: this.props.selectedInstrumentDetail?.setPositionVal,
                activeIndex: this.props.selectedKeyedInDetails?.setPositionVal,
                activeDirectionIndx: this.props.activeDirectionIndx ? this.props.activeDirectionIndx : 0
            })
        }
    }
    private goToPrevSlide = (e: any) => {
        e.preventDefault();
        let index = this.state.activeMeasuredIndex;

        if (this.props.selectedInstrumentDetail.countData.length > 1) {
            const slidesLength = this.props.selectedInstrumentDetail.countData.length - 1;
            if (!this.props.selectedInstrumentDetail.isAutoLine) {
                if (this.props.selectedInstrumentDetail.setPositionVal !== 0) {
                    let ind = this.props.selectedInstrumentDetail.setPositionVal
                    if (ind < 1) {
                        ind = slidesLength;
                    }
                    --ind;
                    this.props.onMeasuredPositionChange(ind);
                    this.setState({
                        activeMeasuredIndex: ind
                    });
                }
            } else {
                if (this.state.activeMeasuredIndex !== 0) {
                    if (index < 1) {
                        index = slidesLength;
                    }
                    --index;
                    this.props.onMeasuredPositionChange(index);
                    this.setState({
                        activeMeasuredIndex: index
                    });
                }
            }

        } else {
            const slidesLength = this.props.selectedInstrumentDetail.countData.length;
            if (index < 1) {
                index = slidesLength;
            }
            --index;
            this.props.onMeasuredPositionChange(index);
            this.setState({
                activeMeasuredIndex: index
            });
        }
    }

    private goToNextSlide = (e: any) => {
        e.preventDefault();
        let index = this.state.activeMeasuredIndex;
        const slidesLength = this.props.selectedInstrumentDetail.countData.length - 1;
        // tslint:disable-next-line: no-empty
        if (index === slidesLength) {

        } else {
            if (!this.props.selectedInstrumentDetail.isAutoLine) {
                if (slidesLength !== this.props.selectedInstrumentDetail.setPositionVal) {
                    ++index;
                    this.props.onMeasuredPositionChange(index);
                    this.setState({
                        activeMeasuredIndex: index
                    });
                }
            } else {
                ++index;
                this.props.onMeasuredPositionChange(index);
                this.setState({
                    activeMeasuredIndex: index
                });
            }
        }
    }

    private dashboardContent() {
        if (this.props.measuredSection) {
            return (
                <Translation>
                    {
                        t =>
                            <div className="col-12" style={{ height: 102 }}>
                                <div style={{ paddingTop: 65 }}>
                                    <span className="sample-count-text title font-weight-bold float-left">{t(CONSTANTS.LABEL_TOTALCOUNT)} </span>
                                    <span className="vertical-line-left float-right mt-0">
                                        <span className="sidebar-main-subtitle ml-1">{this.props.selectedInstrumentDetail.count.completedCounts}
                                            ({this.props.selectedInstrumentDetail.count.totalCounts})</span>
                                    </span>
                                    <div className="clearfix" />
                                </div>
                            </div>
                    }
                </Translation>
            );
        } else if (this.props.keyedInSection) {
            const kCountData = this.props.selectedKeyedInDetails?.countData?.find(x => x.selected);
            const kselectedDirection = kCountData?.directions?.find(x => x.selected);
            return (
                <Translation>
                    {
                        t =>
                            <div className="col-12 py-2 font-12px" >
                                <div style={{ paddingTop: 50 }}>
                                    <hr className="hr-line mb-2 mb-12px" />
                                    <span className="sample-count-text sidebar-main-subtitle font-weight-bold float-left mt-2">{t(CONSTANTS.LABEL_TOTALCOUNT)} </span>
                                    <span className="vertical-line-left float-right">
                                        <span className="sidebar-main-subtitle ml-1">{kselectedDirection.completedCounts}({kselectedDirection.totalCounts})</span>
                                    </span>
                                    <div className="clearfix" />
                                </div>
                            </div>
                    }
                </Translation>
            );
        } else {
            return <div className="col-12 py-2 pt-3 font-12px" >
                <span className="sample-count-text sidebar-main-subtitle font-weight-bold float-left mt-2"></span>
                <span className="">
                    <span className="sidebar-main-subtitle ml-1"></span>

                </span>
                <div className="clearfix mt-1" />
            </div>
        }
    }

    private measuredPosition() {
        return <React.Fragment>
            {this.props.selectedInstrumentDetail?.count?.totalCounts != 1 &&
                <span className={(this.state.activeMeasuredIndex == 0) ? "disableArrowIcon carousel__arrow carousel__arrow--left" : "enableArrowIcon carousel__arrow carousel__arrow--left"}>
                    <Icon
                        name={ABB_LEFT}
                        sizeClass="large"

                        // tslint:disable-next-line: jsx-no-lambda
                        onClick={(e: any) => this.goToPrevSlide(e)} />
                </span>
            }
            <ul className="carousel__slides" style={{ display: "inline-flex", alignItems: "center", width: "160px" }}>
                {this.props.selectedInstrumentDetail?.countData?.map((slide, index) => {
                    let countData = this.props.selectedInstrumentDetail?.countData?.find(x => x.selected);
                    if (!countData) {
                        countData = this.props.selectedInstrumentDetail.countData[0];
                    }
                    let selectedDirection: any;
                    let totalCompleted: any;
                    if (slide !== undefined) {
                        selectedDirection = slide.directions.find(x => x.selected);
                        if (!selectedDirection) {
                            selectedDirection = slide.directions[0];
                        }
                        if (selectedDirection?.completedCounts === 0 && selectedDirection?.totalCounts === 0) {
                            totalCompleted = false;
                        } else {
                            totalCompleted = selectedDirection?.completedCounts === selectedDirection?.totalCounts;
                        }
                    }
                    const activeItem = this.props.selectedInstrumentDetail.isAutoLine ? this.state.activeMeasuredIndex
                        : this.props.selectedInstrumentDetail.setPositionVal;
                    if (this.props.selectedInstrumentDetail.isAutoLine) {
                        if (selectedDirection !== undefined) {
                            if (selectedDirection?.completedCounts === 0 && selectedDirection?.totalCounts === 0) {
                                totalCompleted = false
                            } else {
                                totalCompleted = true
                            }
                        }
                    }
                    return <React.Fragment key={index}>

                        <li
                            key={index}
                            className={
                                index - 1 === activeItem
                                    ? "carousel__slide carousel__slide--leftactive"
                                    : "carousel__slide"
                            }
                        >
                            <PropertyMeasurement name={slide.positionName}
                                color={totalCompleted ? "green" : "black"}
                                count={String(slide.position)}
                                isAutoLine={this.props.selectedInstrumentDetail.isAutoLine}
                                selectedDirection={selectedDirection}
                            />
                        </li>

                        <li
                            key={index}
                            className={
                                index === activeItem
                                    ? "carousel__slide carousel__slide--active"
                                    : "carousel__slide"
                            }
                        >
                            <PropertyMeasurement name={slide.positionName}
                                color={totalCompleted ? "green" : "black"}
                                count={String(slide.position)}
                                isAutoLine={this.props.selectedInstrumentDetail.isAutoLine}
                                selectedDirection={selectedDirection}
                                isActive={true}
                            />
                        </li>

                        <li
                            key={index}
                            className={
                                activeItem === index + 1
                                    ? "carousel__slide carousel__slide--rightactive"
                                    : "carousel__slide"
                            }
                        >
                            <PropertyMeasurement name={slide.positionName}
                                color={totalCompleted ? "green" : "black"}
                                count={String(slide.position)}
                                isAutoLine={this.props.selectedInstrumentDetail.isAutoLine}
                                selectedDirection={selectedDirection}
                            />
                        </li>

                    </React.Fragment>
                })}
            </ul>
            {this.props.selectedInstrumentDetail?.count?.totalCounts != 1 &&
                <Icon
                    name={ABB_RIGHT}
                    sizeClass="large"
                    className={(this.props.selectedInstrumentDetail.countData.length - 1 == this.state.activeMeasuredIndex) ? "disableArrowIcon carousel__arrow carousel__arrow--right" : "enableArrowIcon carousel__arrow carousel__arrow--right"}
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick={(e: any) => this.goToNextSlide(e)} />
            }
        </React.Fragment>
    }

    private createMeasuredDashboard = () => {
        const items: any[] = [];
        const countData = this.props.selectedInstrumentDetail?.countData;

        if (this.props.selectedInstrumentDetail?.isAutoLine) {
            const positionData = this.props.selectedInstrumentDetail.countData;
            positionData.map((data, index) => {
                items.push(<td style={{ width: "124px" }} key={index + Math.random()}>
                    <PropertyMeasurement name={data.positionName}
                        color={data.position === -1 ? "black" : "green"}
                    /></td>);
            });
            return <tr className="normal-class">{items}</tr>;
        } else {
            countData.map((data, index) => {
                const counts = data.directions.find(x => x.name === "All");
                items.push(<td key={index + Math.random()}>
                    <PropertyMeasurement name={data.positionName}
                        color={counts.totalCounts === counts.completedCounts ? "green" : "black"} />
                    <div className="text-center">
                        {(data.directions || []).map(x => {
                            if (x.name === "All") {
                                if (x.completedCounts === 0) {
                                    return <span className="secondary-text">Pending</span>
                                } else if (x.completedCounts === x.totalCounts) {
                                    return <span className="secondary-text">Completed</span>
                                } else {
                                    return <span className="secondary-text" style={{ color: "#36f" }}>Measuring</span>
                                }
                            }
                        })}
                    </div>
                </td>);
            });
            return <tr className="normal-class">{items}</tr>;
        }
    }

    onScroll(e: any) {
        const elm = document.getElementById("scrollBar").scrollLeft;
        document.getElementById("autolinescroll").scrollLeft = elm;
    }

    // keyedins
    private createKeyedInDashboard = () => {
        const items: any[] = [];
        const count = this.props.selectedKeyedInDetails.counts;
        const countData = this.props.selectedKeyedInDetails.countData;
        if (count.length > 0) {
            countData.map((data, index) => {
                items.push(<div className="col" key={index} style={{ marginLeft: 16 }}><PropertyMeasurement
                    name={data.positionName}
                    color={data.directions[0].totalCounts === data.directions[0].completedCounts ? "green" : "black"} />
                    <div className="text-center">
                        {(data.directions || []).map(x => {
                            if (x.completedCounts === 0) {
                                return <span className="secondary-text">Pending</span>
                            } else if (x.completedCounts === x.totalCounts) {
                                return <span className="secondary-text">Completed</span>
                            } else {
                                return <span className="secondary-text" style={{ color: "#36f" }}>Measuring</span>
                            }
                        })}
                    </div>
                </div>);
            });
        }
        return <div className="row" style={{ flexFlow: 'nowrap', width: '100%' }}>{items}</div>;
    }
    private keyedInPosition() {
        return <React.Fragment>
            {this.props.selectedInstrumentDetail.count.totalCounts != 1 &&
                <span className={(this.state.activeMeasuredIndex == 0) ? "disableArrowIcon carousel__arrow carousel__arrow--left" : "enableArrowIcon carousel__arrow carousel__arrow--left"}>
                    <Icon
                        name={ABB_LEFT}
                        sizeClass="large"
                        // tslint:disable-next-line: jsx-no-lambda
                        onClick={(e: any) => this.goToKeyedInPrevSlide(e)} />
                </span>
            }
            <ul className="carousel__slides row" style={{ display: "inline-flex", alignItems: "center", width: "160px" }}>
                {this.props.selectedKeyedInDetails.countData.map((slide, index) => {
                    const countData = this.props.selectedKeyedInDetails.countData.find(x => x.selected);
                    const selectedDirection = slide.directions.find(x => x.selected);
                    const selectedPosition = this.props.selectedKeyedInDetails.directionCounts.find(x => x.position === slide.position && x.name === slide.positionName);
                    return <React.Fragment key={index}>
                        <li key={index}
                            className={index - 1 === this.props.selectedKeyedInDetails.setPositionVal ? "carousel__slide carousel__slide--leftactive" :
                                "carousel__slide"}>
                            <PropertyMeasurement
                                name={slide.positionName}
                                color={selectedPosition?.completedCounts === selectedPosition?.totalCounts ? "green" : "black"}
                                count={String(slide.position)} />
                        </li>
                        <li key={index}
                            className={index === this.props.selectedKeyedInDetails.setPositionVal ? "carousel__slide carousel__slide--active" :
                                "carousel__slide"}>
                            <PropertyMeasurement
                                name={slide.positionName}
                                color={selectedPosition?.completedCounts === selectedPosition?.totalCounts ? "green" : "black"}
                                isActive={true}
                                count={String(slide.position)} />
                        </li>

                        <li key={index}
                            className={
                                this.props.selectedKeyedInDetails.setPositionVal === index + 1
                                    ? "carousel__slide carousel__slide--rightactive"
                                    : "carousel__slide"
                            }>
                            <PropertyMeasurement name={slide.positionName}
                                color={selectedPosition?.completedCounts === selectedPosition?.totalCounts ? "green" : "black"}
                                count={String(slide.position)}
                            />
                        </li>

                    </React.Fragment>

                })}
            </ul>
            {this.props.selectedInstrumentDetail.count.totalCounts != 1 &&
                <Icon
                    name={ABB_RIGHT}
                    sizeClass="large"
                    className={(this.props.selectedInstrumentDetail.countData.length - 1 == this.state.activeMeasuredIndex) ? "disableArrowIcon carousel__arrow carousel__arrow--right" : "enableArrowIcon carousel__arrow carousel__arrow--right"}
                    // tslint:disable-next-line: jsx-no-lambda
                    onClick={(e: any) => this.goToKeyedInNextSlide(e)} />
            }
        </React.Fragment>
    }

    private goToKeyedInPrevSlide = (e: any) => {
        e.preventDefault();
        let index = this.state.activeIndex;

        if (this.props.selectedKeyedInDetails.countData.length > 1) {
            const slidesLength = this.props.selectedKeyedInDetails.countData.length - 1;
            if (this.state.activeIndex !== 0) {
                if (index < 1) {
                    index = slidesLength;
                }
                --index;
                this.props.onKeyedInPositionChange(index);
                this.setState({
                    activeIndex: index
                });
            }
        } else {
            const slidesLength = this.props.selectedKeyedInDetails.countData.length;
            if (index < 1) {
                index = slidesLength;
            }
            --index;
            this.props.onKeyedInPositionChange(index)
            this.setState({
                activeIndex: index
            });
        }

    }

    private goToKeyedInNextSlide = (e: any) => {
        e.preventDefault();
        let index = this.state.activeIndex;
        const slidesLength = this.props.selectedKeyedInDetails.countData.length - 1;
        if (index === slidesLength) {
            index = -1;
        } else {
            ++index;
            this.props.onKeyedInPositionChange(index);
            this.setState({
                activeIndex: index
            });
        }
    }
    private onSetActiveDirectionIndx = (index: number) => {
        this.setState({ activeDirectionIndx: index },
            () => {
                this.props.onSetActiveDirectionIndx(index);
            });
    }

    public render() {
        const kCountData = this.props.selectedKeyedInDetails?.countData?.find(x => x.selected);
        const kselectedDirection = kCountData?.directions?.find(x => x.selected);
        const dirCount = this.props.selectedKeyedInDetails?.directionCounts?.find((x) => x.direction.id === kselectedDirection.id)
        const keyedInDetails = kselectedDirection !== undefined &&
            <Translation>
                {
                    t =>
                        <React.Fragment>
                            <span className="sample-count-text sidebar-main-subtitle font-weight-bold float-left mt-2">{t(CONSTANTS.LABEL_TOTALCOUNT)}</span>
                            <span className="vertical-line-left float-right">
                                {dirCount !== undefined ?
                                    <span className="sidebar-main-subtitle ml-1">{dirCount.completedCounts}({dirCount.totalCounts})</span> :
                                    <span className="sidebar-main-subtitle ml-1">0({kselectedDirection.totalCounts})</span>
                                }
                            </span>
                            <div className="clearfix" />
                        </React.Fragment>
                }
            </Translation>

        const countData = this.props.selectedInstrumentDetail?.countData?.find(x => x.selected);
        let selectedDirection: any;
        if (countData !== undefined) {
            selectedDirection = countData.directions.find(x => x.selected);
        }

        const measuredDetails =
            <Translation>
                {
                    t =>
                        <React.Fragment>

                            <span className="sample-count-text sidebar-main-title font-weight-bold float-left">{t(CONSTANTS.LABEL_TOTALCOUNT)} </span>
                            {this.props.selectedInstrumentDetail?.isAutoLine ? selectedDirection !== undefined && <span className="vertical-line-left float-right">
                                {selectedDirection.totalCounts === selectedDirection.totalCounts ?
                                    <Icon name={ABB_CHECK_MARK} sizeClass="small" className="ml-2" color="green" />
                                    : null
                                }
                                <span className="sidebar-main-subtitle ml-1">{selectedDirection.totalCounts}({selectedDirection.totalCounts})</span>
                            </span> :
                                selectedDirection !== undefined && <span className="vertical-line-left float-right">
                                    {selectedDirection.completedCounts === selectedDirection.totalCounts ?
                                        <Icon name={ABB_CHECK_MARK} sizeClass="small" className="ml-2" color="green" />
                                        : null
                                    }
                                    <span className="sidebar-main-subtitle ml-1">{selectedDirection.completedCounts}({selectedDirection.totalCounts})</span>
                                </span>
                            }
                            <div className="clearfix" />
                        </React.Fragment>
                }
            </Translation>

        return (
            <Translation>

                {

                    t =>
                        <div className="instrument-content-bg">
                            <div className={this.props.isFullScreenVisible ? "tab-content instrument-content-fullscreen" : this.props.showSummary ? "tab-content instrument-content-hide-summary" : "tab-content instrument-content"}>
                                <div
                                    className="tab-pane fade show active"
                                    role="tabpanel"
                                    aria-labelledby="pills-home-tab"
                                >
                                    <React.Fragment>
                                        <div >
                                            {this.props?.thresholdSettings?.map((th: IThresholdSettings, i: number) => {
                                                return th.key === 'RJLT' || th.key === 'ALLT2' || th.key === 'ALLT1' || th.key === 'MEAN' ? <div className="fl threshold" key={i}>
                                                    <div key={Math.random()} className="fl threshold-box" style={{ background: th?.colorCode }} />
                                                    <span key={Math.random()} className="fl threshold-text">{t(th?.name)} </span></div> : ""
                                            })}
                                        </div>
                                        <div className="clearfix" />
                                    </React.Fragment>
                                    <div className="row no-padding-b" style={{ height: 100 }}>
                                        {this.props.details && !this.props.calculatedSection ?
                                            <div className="row col-12">
                                                <div className="col-md-4 p-4 left-pan-res no-padding-b no-padding-t">
                                                    {this.props.measuredSection ? measuredDetails : keyedInDetails}
                                                </div>
                                                <div className="col-3"></div>
                                                <div className="col-4">
                                                    <div style={{ paddingLeft: "10%" }}>
                                                        <div>
                                                            {this.props.measuredSection ? this.measuredPosition() : null}
                                                            {this.props.keyedInSection ? this.keyedInPosition() : null}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div className="rowAutoline"
                                                style={{ paddingTop: 4, width: "100%" }}
                                            >
                                                <div className="col-md-4 p-4 left-pan-res no-padding-b no-padding-t">
                                                    {this.props.measuredSection ? measuredDetails : keyedInDetails}
                                                </div>
                                                <div style={{ paddingRight: "35px" }} className="col-8  autolineScrollTop" id="scrollBar" onScroll={this.onScroll}>
                                                    <table className="measurement-tbl one">
                                                        <tbody>
                                                            {this.props.measuredSection && this.createMeasuredDashboard()}
                                                            {this.props.keyedInSection && this.createKeyedInDashboard()}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>

                                        }
                                    </div>

                                    {this.props.selectedInstrumentDetail?.allDirections?.sort((a: any, b: any) => { return a.order - b.order })}
                                    {this.props.measuredSection &&
                                        this.props.selectedInstrumentDetail?.allDirections?.map((data, index) => {
                                            return <React.Fragment key={Math.random()}>

                                                <span style={{ cursor: "pointer", fontWeight: this.state.activeDirectionIndx === index ? 'bold' : 'normal', fontSize: this.state.activeDirectionIndx === index ? '16px' : '14px' }} onClick={() => this.onSetActiveDirectionIndx(index)}>
                                                    {this.state.activeDirectionIndx === index ?
                                                        <Icon className="mr-3" name={ABB_CARET_DOWN} /> :
                                                        <Icon className="mr-3" name={ABB_CARET_UP} />
                                                    }{data.name}</span>
                                                <hr className="hr-line" />
                                                {this.state.activeDirectionIndx === index && <div className="row no-padding-b">
                                                    <div className="col-md-4 left-pan-res no-padding-b no-padding-t">
                                                        <PropertyTable
                                                            meauredSection={this.props.measuredSection}
                                                            keyedInSection={this.props.keyedInSection}
                                                            calculatedSection={this.props.calculatedSection}
                                                            selectedKeyedInDetails={this.props.selectedKeyedInDetails}
                                                            selectedInstrumentDetail={this.props.selectedInstrumentDetail}
                                                            selectedCalculatedDetails={this.props.selectedCalculatedDetails}
                                                            details={this.props.details}
                                                            selectedDirection={data}
                                                            thresholdSettings={this.props.thresholdSettings}
                                                        />
                                                    </div>
                                                    <div className="d-inline border-right border-dark" />
                                                    <div style={{ width: "65%" }}>
                                                        <div className="col-md-12">
                                                            <MeasurementTable
                                                                measuredSection={this.props.measuredSection}
                                                                keyedInSection={this.props.keyedInSection}
                                                                calculatedSection={this.props.calculatedSection}
                                                                details={this.props.details}
                                                                selectedKeyedInDetails={this.props.selectedKeyedInDetails}
                                                                selectedInstrumentDetail={this.props.selectedInstrumentDetail}
                                                                selectedCalculatedDetails={this.props.selectedCalculatedDetails}
                                                                // tslint:disable-next-line: jsx-no-lambda
                                                                onMeasuredPositionChange={this.props.onMeasuredPositionChange}
                                                                onKeyedInPositionChange={this.props.onKeyedInPositionChange}
                                                                isLoadingText={this.props.isLoadingText}
                                                                selectedDirection={data}
                                                                thresholdSettings={this.props.thresholdSettings}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>}
                                            </React.Fragment>
                                        })
                                    }

                                    {this.props.keyedInSection && <div className="row no-padding-b">
                                        <div className="col-md-4 left-pan-res no-padding-b no-padding-t">
                                            <PropertyTable
                                                meauredSection={this.props.measuredSection}
                                                keyedInSection={this.props.keyedInSection}
                                                calculatedSection={this.props.calculatedSection}
                                                selectedKeyedInDetails={this.props.selectedKeyedInDetails}
                                                selectedInstrumentDetail={this.props.selectedInstrumentDetail}
                                                selectedCalculatedDetails={this.props.selectedCalculatedDetails}
                                                details={this.props.details}
                                                thresholdSettings={this.props.thresholdSettings}
                                            />
                                        </div>
                                        <div className="d-inline border-right border-dark" />
                                        <div style={{ width: "65%" }}>
                                            <div className="col-md-12">
                                                <MeasurementTable
                                                    measuredSection={this.props.measuredSection}
                                                    keyedInSection={this.props.keyedInSection}
                                                    calculatedSection={this.props.calculatedSection}
                                                    details={this.props.details}
                                                    selectedKeyedInDetails={this.props.selectedKeyedInDetails}
                                                    selectedInstrumentDetail={this.props.selectedInstrumentDetail}
                                                    selectedCalculatedDetails={this.props.selectedCalculatedDetails}
                                                    // tslint:disable-next-line: jsx-no-lambda
                                                    onMeasuredPositionChange={this.props.onMeasuredPositionChange}
                                                    onKeyedInPositionChange={this.props.onKeyedInPositionChange}
                                                    isLoadingText={this.props.isLoadingText}
                                                    thresholdSettings={this.props.thresholdSettings}
                                                />
                                            </div>
                                        </div>
                                    </div>}

                                    {this.props.calculatedSection && <div className="row no-padding-b">
                                        <div className="col-md-4 left-pan-res no-padding-b no-padding-t">
                                            <PropertyTable
                                                meauredSection={this.props.measuredSection}
                                                keyedInSection={this.props.keyedInSection}
                                                calculatedSection={this.props.calculatedSection}
                                                selectedKeyedInDetails={this.props.selectedKeyedInDetails}
                                                selectedInstrumentDetail={this.props.selectedInstrumentDetail}
                                                selectedCalculatedDetails={this.props.selectedCalculatedDetails}
                                                details={this.props.details}
                                                thresholdSettings={this.props.thresholdSettings}
                                            />
                                        </div>
                                        <div className="d-inline border-right border-dark" />
                                        <div style={{ width: "65%" }}>
                                            <div className="col-md-12">
                                                <MeasurementTable
                                                    measuredSection={this.props.measuredSection}
                                                    keyedInSection={this.props.keyedInSection}
                                                    calculatedSection={this.props.calculatedSection}
                                                    details={this.props.details}
                                                    selectedKeyedInDetails={this.props.selectedKeyedInDetails}
                                                    selectedInstrumentDetail={this.props.selectedInstrumentDetail}
                                                    selectedCalculatedDetails={this.props.selectedCalculatedDetails}
                                                    // tslint:disable-next-line: jsx-no-lambda
                                                    onMeasuredPositionChange={this.props.onMeasuredPositionChange}
                                                    onKeyedInPositionChange={this.props.onKeyedInPositionChange}
                                                    isLoadingText={this.props.isLoadingText}
                                                    thresholdSettings={this.props.thresholdSettings}
                                                />
                                            </div>
                                        </div>
                                    </div>}





                                </div>
                            </div>
                        </div>}
            </Translation>
        )
    }

}